/* How it works: research library topic chips. Progressive enhancement: every study is visible without JS. */
(function () {
  var d = document;
  d.querySelectorAll('[data-hiw-chips]').forEach(function (group) {
    var root = group.closest('.hiw-lib'), list = root.querySelector('[data-hiw-list]'), live = root.querySelector('[data-hiw-count]');
    var items = [].slice.call(list.children), chips = [].slice.call(group.querySelectorAll('[data-topic]'));
    var more = root.querySelector('[data-hiw-more]'), limit = more ? parseInt(more.dataset.hiwMore, 10) || 0 : 0, expanded = !limit || items.length <= limit;
    group.hidden = false;
    function apply(topic, announce) {
      var n = 0;
      items.forEach(function (li) { var show = (!topic || li.dataset.topic === topic) && (topic || expanded || n < limit); li.hidden = !show; if (show) n++; });
      if (more) more.hidden = !!topic || expanded;
      chips.forEach(function (c) { c.setAttribute('aria-pressed', c.dataset.topic === topic ? 'true' : 'false'); });
      if (announce && live) live.textContent = n + (n === 1 ? ' study' : ' studies');
    }
    chips.forEach(function (c) { c.addEventListener('click', function () { apply(c.dataset.topic, true); }); });
    if (more) more.addEventListener('click', function () { var first = items.filter(function (li) { return li.hidden; })[0]; expanded = true; apply('', true); if (first) first.focus(); });
    apply('', false);
    /* A citation link elsewhere on the page jumps to its card: show everything first so the target is never hidden */
    d.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#study-"], a[href^="#bg-"]'); if (!a) return;
      var target = d.getElementById(a.getAttribute('href').slice(1)); if (!target) return;
      if (target.hidden) { expanded = true; apply('', false); }
      var det = target.closest('details'); if (det) det.open = true;
      setTimeout(function () { target.focus({ preventScroll: true }); }, 0);
    });
  });
})();
